import axios from "axios";
import { SHAREPOINT_CONN_NAME } from "../config/serviceConstant";
// const base_url = process.env.REACT_APP_API_SERVER_URL;

const base_url = process.env.REACT_APP_API_SERVER_URL + "/sharepoint";
const setting_url = `${process.env.REACT_APP_ADMIN_SERVER_URL}/db/planetscale/clients/settings`;

const headers = {
  Accept: "*/*",
  "Content-Type": "application/json",
};

export const getSharePointSites = async ({
  connname,
  orgid,
  apikey,
  datacenterurl,
}) => {
  let reqOptions = {
    url: `${base_url}/root/sites`,
    method: "GET",
    headers: {
      ...headers,
      connname: SHAREPOINT_CONN_NAME,
      orgid,
      apikey,
      datacenterurl,
    },
  };

  try {
    const sitesResp = await axios(reqOptions);
    return sitesResp?.data;
  } catch (error) {
    return { error: error?.response?.statusText };
  }
};

// Get Folders Item
export const getFoldersItem = async (
  folder_id,
  connname,
  orgid,
  apikey,
  datacenterurl,
  settingUrl = process.env.REACT_APP_DRIVEMANAGER_SETTING_URL,
  driveId,
  siteId = "",
  onlyFolder = "false"
) => {
  let url = `${base_url}/files`;
  if (onlyFolder) {
    url = url + `?onlyFolder=${onlyFolder}`;
  }
  let reqOptions = {
    url: url,
    method: "post",
    headers: {
      ...headers,
      connname: SHAREPOINT_CONN_NAME,
      orgid,
      apikey,
      datacenterurl,
    },
    data: {
      fileId: folder_id,
      driveId: driveId,
      siteId: siteId,
    },
  };

  try {
    const folderResp = await axios(reqOptions);
    return folderResp?.data;
  } catch (error) {
    return { error: error?.response?.statusText };
  }
};

export const createFolder = (
  folder_id,
  data,
  connname,
  orgid,
  apikey,
  datacenterurl,
  settingUrl = process.env.REACT_APP_DRIVEMANAGER_SETTING_URL,
  driveId,
  siteId
) => {
  const URL = `${base_url}/create`;

  let reqOptions = {
    url: URL,
    method: "POST",
    headers: {
      ...headers,
      connname: SHAREPOINT_CONN_NAME,
      orgid,
      apikey,
      datacenterurl,
    },
    data: {
      ...data,
      fileId: folder_id,
      driveId: driveId,
      siteId: siteId,
    },
  };

  return axios(reqOptions)
    .then((response) => {
      return response?.data;
    })
    .catch((error) => {
      throw error;
    });
};

export const getFoldersData = async (
  folder_id = "root",
  connname,
  orgid,
  apikey,
  datacenterurl,
  settingUrl = process.env.REACT_APP_DRIVEMANAGER_SETTING_URL,
  driveId
) => {
  let reqOptions = {
    url: `${base_url}/file/details`,
    method: "post",
    headers: {
      ...headers,
      connname: SHAREPOINT_CONN_NAME,
      orgid,
      apikey,
      datacenterurl,
    },
    data: {
      fileId: folder_id,
      driveId: driveId,
    },
  };

  try {
    const folderResp = await axios(reqOptions);
    return folderResp?.data;
  } catch (error) {
    return { error: error?.response?.statusText };
  }
};

// TODO connname, orgid, apikey should get from CRM variable
export const getDriveRootFolders = async ({
  connname,
  orgid,
  apikey,
  siteId,
  driveId,
  datacenterurl,
}) => {
  let reqOptions = {
    url: `${base_url}/drive/files`,
    method: "post",
    headers: {
      ...headers,
      connname: SHAREPOINT_CONN_NAME,
      orgid,
      apikey,
      datacenterurl,
    },
    data: {
      siteId: siteId,
      driveId: driveId,
    },
  };

  try {
    const driveResp = await axios(reqOptions);
    return driveResp?.data;
  } catch (error) {
    return { error: error?.response?.statusText };
  }
};

// TODO connname, orgid, apikey should get from CRM variable
export const getCronJobs = async (data) => {
  const { connname, orgid, apikey } = data;

  try {
    const base_url = process.env.REACT_APP_ADMIN_SERVER_URL;
    const crons = await axios({
      url: base_url + "/utils/cronjobs",
      method: "get",
      headers: {
        orgid: orgid,
        connname: connname,
        apikey: apikey,
      },
    });
    return crons?.data;
  } catch (error) {
    return error;
  }
};

export const getCronJobsOrg = async (data) => {
  const { orgid, apikey } = data;

  try {
    const base_url = process.env.REACT_APP_ADMIN_SERVER_URL;
    const crons = await axios({
      url: base_url + "/utils/cronjoborg",
      method: "get",
      headers: {
        orgid: orgid,
        connname: "easysharepointforcrm",
        apikey: apikey,
      },
    });

    return crons?.data;
  } catch (error) {
    return error;
  }
};

export const createCronJobOrg = async (data, headers) => {
  try {
    const base_url = process.env.REACT_APP_ADMIN_SERVER_URL;
    const createCron = await axios({
      url: base_url + "/utils/cronjoborg",
      method: "post",
      headers: headers,
      data: data,
    });

    return createCron?.data;
  } catch (error) {
    return error;
  }
};

export const deleteCronJobOrg = async (data) => {
  const { orgid, apikey, settingId } = data;

  try {
    const base_url = process.env.REACT_APP_ADMIN_SERVER_URL;
    const cronDeleteConfig = {
      url: `${base_url}/utils/cronjoborg/${settingId}`,
      method: "DELETE",
      headers: {
        orgid: orgid, // Org ID
        apikey: apikey, // API KEy
        connname: "easysharepointforcrm", // Conn Name
      },
    };

    const deleteCron = await axios(cronDeleteConfig);
    return deleteCron?.data;
  } catch (deleteCronJob) {
    return deleteCronJob;
  }
};

// TODO connname, orgid, apikey should get from CRM variable
export const createCronJob = async (data) => {
  const { reqUrl, reqParams, reqHeaders, reqBody, reqType } = data;
  const { orgid, connname, apikey, datacenterurl } = reqHeaders;
  let params = {};

  try {
    const base_url = process.env.REACT_APP_ADMIN_SERVER_URL;
    const createCron = await axios({
      url: base_url + "/utils/cronjobs",
      method: "post",
      headers: {
        ...headers,
        orgid: orgid,
        connname: connname,
        apikey: apikey,
        datacenterurl: datacenterurl,
      },
      data: {
        reqUrl: reqUrl,
        reqParams: reqParams,
        reqHeaders: reqHeaders,
        reqBody: reqBody,
        reqType: reqType,
      },
    });
    return createCron?.data;
  } catch (error) {
    return error;
  }
};

// TODO connname, orgid, apikey should get from CRM variable
export const getCustomViewData = async (data) => {
  const {
    moduleApiName,
    cvid,
    connname,
    orgid,
    apikey,
    datacenterurl,
    settingUrl = process.env.REACT_APP_DRIVEMANAGER_SETTING_URL,
  } = data;

  // You can pass the data in body/parsms
  let reqOptions = {
    url: `${process.env.REACT_APP_ADMIN_SERVER_URL}/data/zoho/crm/modules/${moduleApiName}/cvid/${cvid}`,
    method: "GET",
    headers: {
      ...headers,
      connname: "easysharepointforcrm__zoho",
      orgid,
      apikey,
      Datacenterurl: datacenterurl,
    },
  };

  try {
    const settingResp = await axios(reqOptions);
    return settingResp?.data;
  } catch (error) {
    return { error: error?.response?.statusText };
  }
};

// TODO connname, orgid, apikey should get from CRM variable
export const getSettingData = async (
  moduleApiName = "",
  settingType = "",
  connname,
  orgid,
  apikey,
  datacenterurl,
  settingUrl = process.env.REACT_APP_DRIVEMANAGER_SETTING_URL
) => {
  let params = {};

  if (moduleApiName != "") {
    params["moduleApiName"] = moduleApiName;
  }

  if (settingType != "") {
    params["settingType"] = settingType;
  }

  let reqOptions = {
    url: `${setting_url}`,
    method: "GET",
    headers: {
      ...headers,
      connname: "easysharepointforcrm",
      orgid,
      apikey,
      datacenterurl,
    },
    params: params,
  };

  try {
    const settingResp = await axios(reqOptions);

    return settingResp?.data;
  } catch (error) {
    return { error: error?.response?.statusText };
  }
};
// TODO connname, orgid, apikey should get from CRM variable

export const upsertData = async (
  data = {},
  connname,
  orgid,
  apikey,
  datacenterurl,
  settingUrl = process.env.REACT_APP_DRIVEMANAGER_SETTING_URL
) => {
  let reqOptions = {
    url: `${setting_url}`,
    method: "POST",
    headers: {
      ...headers,
      connname: "easysharepointforcrm",
      orgid,
      apikey,
      datacenterurl,
    },
    data: data,
  };

  try {
    const folderResp = await axios(reqOptions);
    return folderResp?.data;
  } catch (error) {
    return { error: error?.response?.statusText };
  }
};
// upsertData
// TODO connname, orgid, apikey should get from CRM variable

// TODO connname, orgid, apikey should get from CRM variable
export const getSiteDrives = async ({
  connname,
  orgid,
  apikey,
  siteId,
  datacenterurl,
}) => {
  let reqOptions = {
    url: `${base_url}/sites/drives`,
    method: "post",
    headers: {
      ...headers,
      connname: SHAREPOINT_CONN_NAME,
      orgid,
      apikey,
      datacenterurl,
    },
    data: {
      siteId: siteId,
    },
  };

  try {
    const driveResp = await axios(reqOptions);
    return driveResp?.data;
  } catch (error) {
    return { error: error?.response?.statusText };
  }
};

// Get Folders Item
export const getDriveRootFoldersItem = async (
  connname,
  orgid,
  apikey,
  datacenterurl,
  settingUrl = process.env.REACT_APP_DRIVEMANAGER_SETTING_URL
) => {
  let reqOptions = {
    url: `${base_url}/root/files`,
    method: "GET",
    headers: {
      ...headers,
      connname: SHAREPOINT_CONN_NAME,
      orgid,
      apikey,
      datacenterurl,
    },
  };

  try {
    const folderResp = await axios(reqOptions);
    return folderResp?.data;
  } catch (error) {
    return { error: error?.response?.statusText };
  }
};
